import { createApp } from 'vue'
import i18n from './i18n'
import App from './App.vue'
import router from './router'
import store from './store'
import ApiClient from '@/plugins/api-client'
import VueLazyLoad from 'vue3-lazyload';
import '@/assets/icons/icons.css'
import YSF from '@neysf/qiyu-web-sdk';
import mitt from 'mitt'
const emitter = mitt();

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import Vuesax from 'vuesax-alpha'
import 'vuesax-alpha/theme-chalk/index.css'

import '@/assets/styles/index.scss'

let app = createApp(App);
app.config.globalProperties.$customer = null;
app.config.globalProperties.$emitter = emitter;
app
.use(router).use(store)
.use(ApiClient).use(Vuesax).use(ElementPlus)
.use(i18n).use(VueLazyLoad, {
    preLoad: 1.3, // 预加载比例（视口高度的1.3倍）
    error: '/error.jpg', // 图片加载失败时显示的图片（放在public目录）
    loading: '/imgloding.gif', // 加载中显示的占位图
    attempt: 3, // 加载失败重试次数
  })
.mount('#app')
